/**
 * Hook to handle session start/end based on visibility and unload
 */
import { useEffect, useRef } from "react";
import {
  startSession,
  endSession,
  isSessionActive,
} from "../services/analytics-service";
import { db } from "../instantdb";

export function useSessionLifecycle() {
  const { user } = db.useAuth();
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Start session on mount (if not already started by useRouteAnalytics)
    if (!hasInitialized.current) {
      hasInitialized.current = true;
      if (!isSessionActive()) {
        startSession(user?.id);
      }
    }

    // Handle visibility change (tab hidden = potential session end)
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        // End session when tab becomes hidden
        endSession();
      } else if (document.visibilityState === "visible") {
        // Resume or start new session when tab becomes visible
        if (!isSessionActive()) {
          startSession(user?.id);
        }
      }
    };

    // Handle page unload - end session
    const handleBeforeUnload = () => {
      endSession();
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [user?.id]);
}
